import { LAYOUT_SET_PREVIOUS_URL_REQUEST } from './constants';

const INITIAL_STATE = {
  previousUrl: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LAYOUT_SET_PREVIOUS_URL_REQUEST: {
      return {
        ...state,
        previousUrl: action.url
      };
    }

    default:
      return state;
  }
};

export default reducer;
